import React, { useState } from 'react';
import { MessageCircle, Plus, BarChart3, Instagram, Facebook, Music2 } from 'lucide-react';
import { NotificationModal } from '@tadagram/ui';

interface Platform {
  id: string;
  name: string;
  platform: string;
  status: string;
}

interface PlatformSidebarProps {
  platforms: Platform[];
  activePlatform: string;
  onPlatformChange: (platformId: string) => void;
}

interface PlatformOption {
  id: string;
  label: string;
  icon: React.ReactNode;
  count?: number;
}

const STATIC_PLATFORMS: PlatformOption[] = [
  { id: 'facebook',  label: 'Facebook',  icon: <Facebook size={24} /> },
  { id: 'zalo',      label: 'Zalo',      icon: <MessageCircle size={24} /> },
  { id: 'tiktok',    label: 'TikTok',    icon: <Music2 size={24} /> },
  { id: 'instagram', label: 'Instagram', icon: <Instagram size={24} /> },
];

const iconBase =
  'relative w-14 h-14 rounded-[14px] border-none bg-white text-[#707579] cursor-pointer flex items-center justify-center transition-all duration-200 p-0 hover:bg-[#eef4fb] hover:text-[#5288c1]';
const iconActive = '!bg-[#5288c1] !text-white hover:bg-[#4a7ab5] hover:text-white';

export const PlatformSidebar: React.FC<PlatformSidebarProps> = ({
  activePlatform,
  onPlatformChange,
}) => {
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);

  return (
    <div className="w-[72px] bg-[#f4f4f5] border-r border-gray-200 flex flex-col items-center px-2 py-3 gap-3 h-full flex-shrink-0">
      {/* Dashboard Button */}
      <button
        className={`${iconBase} ${!activePlatform ? iconActive : ''}`}
        onClick={() => onPlatformChange('')}
        title="Dashboard"
      >
        <div className="relative flex items-center justify-center">
          <BarChart3 size={24} />
        </div>
      </button>

      {/* Static Platform Buttons */}
      {STATIC_PLATFORMS.map(({ id, label, icon, count }) => (
        <button
          key={id}
          className={`${iconBase} ${activePlatform === id ? iconActive : ''}`}
          onClick={() => onPlatformChange(id)}
          aria-label={`${label}${count ? ` (${count})` : ''}`}
          title={label}
        >
          <div className="relative flex items-center justify-center">
            {icon}
            {count != null && count > 0 && (
              <span className="absolute -top-2 -right-2 min-w-[20px] h-5 px-1.5 bg-[#3fc33b] text-white text-[11px] font-semibold rounded-[10px] flex items-center justify-center border-2 border-white">
                {count > 99 ? '99+' : count}
              </span>
            )}
          </div>
        </button>
      ))}

      {/* Add Platform Button — pinned to bottom */}
      <button
        className={`${iconBase} mt-auto`}
        onClick={() => setIsAddModalOpen(true)}
        title="Thêm nền tảng"
      >
        <div className="relative flex items-center justify-center">
          <Plus size={24} />
        </div>
      </button>

      {/* Add Platform Modal */}
      <NotificationModal
        isOpen={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
        title="Thêm nền tảng"
        message="Tính năng thêm nền tảng mới đang được phát triển. Vui lòng quay lại sau!"
        type="info"
        buttonText="Đã hiểu"
      />
    </div>
  );
};
